import { Link } from 'gatsby';

import '../styles/footer.css';
import '../styles/generic.css';

import { _ } from '../utils/l10n';
import { formatSwissPhoneNumber } from '../utils/formatters';
import { MenuItems, NavLinks } from './MenuItems';
import { useCompanyQuery } from '../queries';
import LinkedInLogo from '../assets/icons/linked-in-logo.svg';
import TrustwiseLogo from '../assets/icons/trustwise-logo-white.svg';

// @todo consider mdx for menu items definitions
const footerMenuItems: NavLinks = {
  'solutions': 'Solutions',
  'use-cases': 'Use Cases',
  'platform/build-your-solution': 'Build Your Solution',
  'platform/architecture': 'Architecture',
  'about/company': 'Company',
  'about/team': 'Team',
  'about/our-partners': 'Our Network',
  'about/news': 'News',
  // @todo switch to nested structure once the component and styles are updated
  // 'platform': {
  //   label: 'Platform',
  //   items: {
  //     'build-your-solution': 'Build Your Solution',
  //     'architecture': 'Architecture',
  //   },
  // },
  // 'about': {
  //   label: 'About us',
  //   items: {
  //     'company': 'Company',
  //     'team': 'Team',
  //     'our-partners': 'Our Network',
  //     'news': 'News',
  //   },
  // },
};

export const Footer = () => {
  const { company_address, contact_email, phone_number } = useCompanyQuery();
  const { city, country, street } = company_address;

  return (
    <footer className="page-footer network-bg">
      <div className="footer-content-top">
        <MenuItems
          className="footer-links"
          items={footerMenuItems}
        />
        {/* @todo make svg button */}
        <img
          src={TrustwiseLogo}
          alt="Trustwise logo"
          id="trustwise-logo-footer"
        />
      </div>
      <div className="footer-content-bottom">
        <div>
          <div className="address">
            <span>trustwise.io ag</span>
            <span>{`${street} ${city} ${country}`}</span>
          </div>
          <div className="contact-info">
            <div className="contact-info-item">
              {_('phone:')}
              <span
                className="phone-number"
                onClick={() => window.open(`tel:${phone_number}`)}
              >
                {formatSwissPhoneNumber(phone_number)}
              </span>
            </div>
            <div className="contact-info-item">
              {_('email:')}
              <span
                className="contact-email"
                onClick={() => (window.location.href = `mailto:${contact_email}`)}
              >
                {contact_email}
              </span>
            </div>
          </div>
          <div className="legal-info">
            <Link to="/privacy">{_('Privacy')}</Link>
          </div>
        </div>
        <a href="https://ch.linkedin.com/company/trustwise-io-ag">
          <img
            src={LinkedInLogo}
            alt="Linked In logo"
            id="linked-in-logo"
          />
        </a>
      </div>
    </footer>
  );
};
